var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"aisea-text-18-600-pure-white menu-title"},[_vm._v(_vm._s(_vm.menuTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }